/**
 * Orden de categorías compartido por POS, carta digital y menú web.
 * El orden lo define el usuario en el módulo "Página Web" y se guarda en
 * config/pagina_web.ordenCategorias (nombres en minúscula).
 * Las categorías no listadas quedan al final, alfabéticas.
 */

/** Devuelve la posición de una categoría (menor = más arriba). */
export const rankCategoria = (orden = []) => {
  const idx = Object.fromEntries(orden.map((c, i) => [c, i]));
  return (cat) => idx[(cat || '').toLowerCase()] ?? 999;
};

/** Ordena una lista de nombres de categoría. */
export const ordenarCategorias = (cats, orden = []) => {
  const rank = rankCategoria(orden);
  return [...cats].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b, 'es'));
};

/** Ordena ítems del catálogo: primero por categoría, luego por nombre. */
export const ordenarCatalogo = (items, orden = []) => {
  const rank = rankCategoria(orden);
  return [...items].sort((a, b) =>
    rank(a.categoria) - rank(b.categoria) ||
    (a.categoria || '').localeCompare(b.categoria || '', 'es') ||
    a.nombre.localeCompare(b.nombre, 'es'));
};
